import { config } from '../services/config';

/** Query param that unlocks /auth/signup when ST-only mode is enabled. */
export const ST_SIGNUP_ALLOW_PARAM = 'ALLOW';

/** Truthy values accepted for ALLOW (case-insensitive). */
const ALLOW_TRUTHY = new Set(['1', 'true', 'yes']);

/**
 * Returns true when the signup page may be shown in ST-only mode.
 * Requires `ALLOW=1|true|yes` in the query string.
 * Outside ST mode this is unused (signup is always open).
 */
export function isStSignupAllowed(search: string): boolean {
  const value = new URLSearchParams(search.startsWith('?') ? search : `?${search}`).get(
    ST_SIGNUP_ALLOW_PARAM
  );
  if (value == null) return false;
  return ALLOW_TRUTHY.has(value.trim().toLowerCase());
}

/**
 * In ST-only mode, ensures ALLOW=1 on a signup path/query.
 * On the public app (non-ST), returns the URL unchanged — no signup gate.
 */
export function withStSignupAllow(pathOrQuery: string): string {
  if (!config.app.stOnlyMode) {
    if (!pathOrQuery) return '/auth/signup';
    if (pathOrQuery.startsWith('/')) return pathOrQuery;
    return `/auth/signup?${pathOrQuery}`;
  }

  if (!pathOrQuery) {
    return `/auth/signup?${ST_SIGNUP_ALLOW_PARAM}=1`;
  }

  const hasPath = pathOrQuery.startsWith('/');
  const url = new URL(hasPath ? pathOrQuery : `/auth/signup?${pathOrQuery}`, 'https://placeholder.local');
  url.searchParams.set(ST_SIGNUP_ALLOW_PARAM, '1');
  return `${url.pathname}?${url.searchParams.toString()}`;
}
